<template>
    <div class="category-card"
        :style="`background-image: url(${data.image});`">
        <div class="card-content">
            <h3 class="category-title">{{ data.title }}</h3>
            <p class="category-subtitle">{{ data.subtitle }}</p>
            <button class="explore-btn">
                <i class="fas fa-arrow-right me-2"></i>{{ data.btn_text }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "CardImageBG",
    props: {
        data: {
            type: Object,
            default: () => {}
        }
    },
    setup() {
        return {};
    },
}
</script>

<style lang="scss">
.category-card {
    height: 350px;
    background: rgba(255, 255, 255, 0.05);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    border: 1px solid rgba(142, 0, 0, 0.5);
    border-radius: 20px;
    padding: 2rem;
    text-align: center;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);
    position: relative;
    overflow: hidden;
}

.category-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(172, 0, 0, 0.1), transparent);
    transition: left 0.5s ease;
}

.category-card:hover::before {
    left: 100%;
}

.category-card:hover {
    transform: translateY(-10px);
    /* box-shadow: 0 20px 40px rgba(255, 215, 0, 0.2); */
    border-color: rgba(142, 0, 0, 0.5);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3),
        0 0 30px rgba(142, 0, 0, 0.3),
        0 0 50px rgba(136, 57, 63, 0.2);
}

.card-content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.6));
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 30px;
    transition: all 0.3s ease;
}

.category-card:hover .card-content {
    background: linear-gradient(135deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.4));
}

.category-title {
    color: white;
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 10px;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.category-subtitle {
    color: rgba(255, 255, 255, 0.9);
    font-size: 1.1rem;
    margin-bottom: 25px;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

.explore-btn {
    display: inline-block;
    padding: 0.8rem 1.5rem;
    background: linear-gradient(45deg, rgba(172, 21, 21, 0.2), rgba(167, 56, 56, 0.2));
    border: 1px solid rgba(255, 215, 0, 0.3);
    border-radius: 25px;
    color: #e6dada;
    text-decoration: none;
    font-weight: 600;
    transition: all 0.3s ease;
}

.explore-btn:hover {
    background: linear-gradient(45deg, rgba(172, 21, 21, 0.3), rgba(205, 86, 78, 0.3));
    transform: scale(1.05);
}
</style>